import Actions from './publishing-destinations-actions';
import Api from './publishing-destinations-api';
import Collection from './publishing-destinations-collection';
import Model from './publishing-destinations-model';
import reducer from './publishing-destinations-reducer';
import sagas from './publishing-destinations-sagas';
import Selectors from './publishing-destinations-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'publishingDestinations',
  reducer,
  sagas:     [sagas],
  Selectors,
};
